<template>
  <div class="valuehead-grid-container">
    <div>
      <img class="head-grid-logo" src="../assets/logo-WMADCC_FNL.jpg">
    </div>

    <div>
      <img class="head-grid-pic" src="../assets/ValueHeader.jpg">
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'ValueHeader'
  }
</script>
  
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .valuehead-grid-container {
    display: grid;
    grid-template-columns: 5fr 6fr;
    background-color: rgb(255, 243, 224);
    height: 20vw;
  }

  .head-grid-logo {
    max-width: 70%;
    max-height: 60%;
    min-height: 18vw;  
    display: flex;
    padding: 1vw;
    margin-left: 8vw; 
    margin-right: 8vw;   
  }

  .head-grid-pic {
    display: flex;
    max-width: 70%;
    max-height: 60%;
    min-height: 17vw;
    margin-left: 6vw;
    margin-top: 1vw;
    border: 5px solid #fff;
  } 
}


/* for Phone */
@media (max-width:700px) {

  .head-grid-logo {
    width: 15rem;
    height: auto;
  }

  img {
    width: 0rem;
    height: 0rem;
    margin-bottom: -2.5rem;
  }  

}

</style>